import { useRef } from "react";
import { View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import { usePaymentOverdueCard } from "./use-payment-overdue-card";
import { useServiceScheduleCard } from "./use-service-schedule-card";
import { usePreviousBookingCard } from "./use-previous-booking-card";
import { useContinueCard } from "./use-continue-card";
import { HorizontalScroll } from "@/components/shared/horizontal-scroll";
import { ListHeading } from "@/components/shared/list-header";
import { TodoCard, type TodoCardProps } from "./TodoCard";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";
import { getPlatform } from "@/lib/utils";
import { HorizontalScrollRef } from "@/components/shared/horizontal-scroll/lib";

export const ToDoWidgets = () => {
  // To Do Widgets
  const paymentOverdueCard = usePaymentOverdueCard();
  const serviceScheduleCard = useServiceScheduleCard();
  const previousBookingCard = usePreviousBookingCard();
  const continueCard = useContinueCard();
  const cards = [
    paymentOverdueCard,
    serviceScheduleCard,
    previousBookingCard,
    continueCard,
  ].filter((c): c is TodoCardProps => c != null);

  // Horizontal Scroll
  const { isDesktop } = useWindowDimensions();
  const platform = getPlatform();
  const paddingLeft = platform === "web" && isDesktop ? 0 : 16;
  const scrollRef = useRef<HorizontalScrollRef>(null);

  if (cards.length === 0) return null;
  return (
    <View className="mt-4 flex flex-col gap-2">
      <View className="mx-4 flex flex-row items-center justify-between gap-2 md:mx-0">
        <ListHeading title="For Your Action" />
        <View className="native:hidden flex flex-row items-center gap-2">
          <IconButton
            variant="secondary"
            color="foreground"
            rounded="full"
            size="sm"
            iconName="caretLeft"
            onClick={() => scrollRef.current?.prev()}
            className="h-7 w-7 border border-input bg-background"
          />
          <IconButton
            variant="secondary"
            color="foreground"
            rounded="full"
            size="sm"
            iconName="caretRight"
            onClick={() => scrollRef.current?.next()}
            className="h-7 w-7 border border-input bg-background"
          />
        </View>
      </View>
      <View className="relative">
        <HorizontalScroll
          ref={scrollRef}
          data={cards}
          itemSpacing={16}
          itemWidth={240}
          contentPadding={{ start: paddingLeft, end: 16 }}
          snap="start"
          renderItem={(card, _index) => <TodoCard {...card} />}
        />
      </View>
    </View>
  );
};
